import MainResidence from './MainResidence';

export default MainResidence;
